'use strict'
import { extractionrAreaCodeData } from '../utilities/index'

export default class tabSwitch {

  constructor(url, pagetype, params) {
    this.tabPickup = document.querySelector('.js-tab-pickup')
    this.tabWatchall = document.querySelector('.js-tab-watchall')

    this.pickupTab = document.querySelector('.js-pickup')
    this.watchallTab = document.querySelector('.js-watchall')
    this.pagetype = pagetype
    this.url = url
    this.params = params

    this.showIdCheck = extractionrAreaCodeData(
      '08',
      window.LIVESTATION.MAINCONTENT
    )[0]
    this.showId = this.showIdCheck.store_name

    this.checkParam()
    this.tabSwitch()
  }

  checkParam() {

    if (this.pagetype == "pickup") {
      //ウォッチオールdisplaynone
      this.watchallTab.classList.add("-none");
      this.pickupTab.classList.remove("-none");
      this.tabWatchall.classList.remove("-active");
      this.tabPickup.classList.add("-active");
      this.url.searchParams.set('autoplay', this.showId);
      history.replaceState({}, '', this.url);
    } else if (this.pagetype == "all") {
      this.pickupTab.classList.add("-none");
      this.tabPickup.classList.remove("-active");
      this.tabWatchall.classList.add("-active");
      this.params.delete('autoplay')
      history.replaceState({}, '', this.url);
    } else {
      //allのパラメータを付与??
      this.url.searchParams.set('type', 'all');
      history.replaceState({}, '', this.url);
    }
  }

  tabSwitch() {
    this.tabPickup.addEventListener('click', () => {
      this.tabWatchall.classList.remove("-active");
      this.tabPickup.classList.add("-active");

      this.pickupTab.classList.remove("-none");
      this.watchallTab.classList.add("-none");

      this.url.searchParams.set('type', 'pickup');
      this.url.searchParams.set('autoplay', this.showId);
      history.replaceState({}, '', this.url);
    });

    this.tabWatchall.addEventListener('click', () => {
      this.tabPickup.classList.remove("-active");
      this.tabWatchall.classList.add("-active");

      this.watchallTab.classList.remove("-none");
      this.pickupTab.classList.add("-none");

      this.url.searchParams.set('type', 'all');
      this.params.delete('autoplay')
      history.replaceState({}, '', this.url);
    });
  }
}

